export default {
  TITLE: '隐私声明',
  CONTENT: `
    <h3>最后更新：2023年11月16日</h3>
    <p>
      我们理解您关心您的信息是如何被使用和共享的，我们非常感谢您相信我们对此事处理的谨慎和敏感。本隐私声明将阐述亚马逊卓越有限公司、北京世纪卓越信息技术有限公司以及其关联公司（合称“亚马逊”或“我们”）是如何通过亚马逊网站、设备、产品、服务、在线商店、小程序及其他适用本隐私声明的应用程序（统称“亚马逊服务”）采集及处理您的个人信息的。
    </p>
    <ul>
      <li>我们采集客户的哪些个人信息？</li>
      <li>我们出于什么目的处理您的个人信息</li>
      <li>什么是Cookies和其他识别码</li>
      <li>我们是否会与他人共享您的个人的信息？</li>
      <li>个人信息跨境提供</li>
      <li>关于我的信息安全</li>
      <li>关于广告</li>
      <li>我能获取哪些信息？</li>
      <li>我有哪些选择？</li>
      <li>我们将在多长时间内存储您的个人信息？</li>
      <li>是否允许未成年人使用本网站？</li>
      <li>使用条件、通知和修订</li>
      <li>相关惯例与信息</li>
      <li>如何联系我们</li>
      <li>其他细节</li>
    </ul>
    <h3>我们采集您的哪些个人信息？</h3>
    <p>我们采集您的个人信息，以提供并持续改进我们的产品与服务。</p>
    <p>我们采集的个人信息种类如下：</p>
    <ul>
      <li>
        您向我们提供的信息：
        我们接收并存储您提供给我们的任何有关亚马逊服务的信息。您可以选择不提供某些信息，但是这样可能使您无法使用部分亚马逊服务。
      </li>
      <li>
        自动获取的信息：
        我们自动接收并存储您关于使用亚马逊服务的特定信息，例如您与亚马逊服务中可获取的内容和服务的交互信息。与其他许多网站一样，我们使用cookies和其他唯一识别码。当您的网络浏览器访问亚马逊服务或由我们或代表我们在其它网站上提供的其他内容时，我们将获得某些信息。
      </li>
      <li>
        从其他来源获得的信息：
        我们可能从其他来源收到关于您的信息，例如在您使用我们的小程序时从小程序运营商获得您的送货地址和手机号码，以便我们向您送达您购买的物品。
      </li>
      <li>
        个人敏感信息：
        在您使用亚马逊服务的过程中，我们可能会收集个人敏感信息。例如，当您购买我们的海外购商品时，我们需要收集识别信息，包括您的<u>身份证号码</u>，以便您购买的商品可以清关。
      </li>
    </ul>
    <p>如需进一步了解我们收集的个人信息详情，请前往本隐私政策的末尾查看。</p>
    <h3>我们出于什么目的处理您的个人信息？</h3>
    <p>
      我们会为了操作、提供、开发和改善我们为客户提供的产品和服务而处理您的个人信息。这些目的包括：
    </p>
    <ul>
      <li>
        产品和服务的购买和交付：我们使用您的个人信息接受和处理订单、交付产品和服务、处理付款，并与您就订单、产品和服务以及促销优惠进行沟通。
      </li>
      <li>
        提供、排除故障和改进亚马逊服务：我们使用您的个人信息来提供功能、分析性能、修复错误，并提高亚马逊服务的可用性和有效性。
      </li>
      <li>
        推荐和个性化：我们使用您的个人信息向您推荐您可能感兴趣的功能、产品和服务，识别您的偏好，并使您的亚马逊服务体验个性化。
      </li>
      <li>
        遵守法定义务：在某些情况下，我们收集并使用您的个人信息是为了遵守法律规定。例如，我们收集您的个人身份信息，包括您的<u>身份证号码</u>，以便您的海外购商品能够清关，并履行我们的备案义务。
      </li>
      <li>
        与您进行沟通：我们使用您的个人信息，从而通过不同的渠道（如电话和电子邮件）与您就亚马逊服务进行沟通。
      </li>
      <li>
        广告：我们使用您的个人信息来显示您可能感兴趣的功能、产品和服务的广告。我们不会使用可识别的个人信息来显示基于兴趣的广告。想要了解更多信息，请阅读本隐私声明的"关于广告"部分。
      </li>
      <li>
        防范欺诈和信用风险：我们使用个人信息来防止和检测欺诈和滥用，以保护我们的客户、亚马逊和其他人的安全。我们还可能使用评分方法来评估和管理信用风险。
      </li>
    </ul>
    <p>如需进一步了解我们收集的个人信息详情，请前往本隐私政策的末尾查看。</p>
    <h3>什么是Cookies和其他识别码？</h3>
    <p>
      为了使我们的系统能够识别您的浏览器或设备，并提供和改进亚马逊服务，我们使用Cookies和其他识别码。有关Cookies和我们如何使用它们的更多信息，请阅读我们的<a data-path='protocol' data-title="COOKIES_POLICY">Cookie政策</a>。
    </p>
    <h3>我们是否会与他人共享所收到的信息？</h3>
    <p>
      客户的信息是我们业务重要的一部分，我们不会将其出售给他人。我们仅以下述方式并与适用本隐私声明或采用不低于本隐私声明所述保护实践的本网站关联公司共享客户信息。这些亚马逊实体可能位于其他国家。
    </p>
    <ul>
      <li>
        涉及第三方的交易：：我们向您提供由第三方提供的服务、产品或应用程序，供您通过亚马逊服务使用。您可以辨别您的交易何时会涉及第三方卖家，我们与该第三方卖家共享与交易有关的客户信息。
      </li>
      <li>
        第三方服务供应商：我们聘请其他公司和个人代表我们履行某些职能。例如，处理产品或服务订单、投递包裹、发送信函或电子邮件、清除客户名单中的重复信息、分析数据、提供市场营销帮助、提供搜索结果和链接（包括付费搜索名单和链接）、处理付款、传输内容、评分、评估和管理信用风险，并提供客户服务。这些第三方服务提供者能够接触到为履行其职责所需的客户信息，但不能将此信息用于任何其他目的。
      </li>
      <li>
        业务转让：为持续发展我们的业务，我们可能会出售或收购业务或服务。在这些交易中，客户信息通常是所转让业务资产中的一部分，但这些信息（当然除非客户作出其他同意）仍然受制于转让前已有的任何隐私声明所作出的承诺。虽然可能性不大，但在极端的情况下，如果本网站或其关联公司或他们各自的全部资产被收购时，客户信息应是被转让资产的一部分。
      </li>
      <li>
        对本网站和其他人的保护：为了遵守法律、执行或适用我们的<a data-path="termStatement" data-title="USE_CONDITION">使用条件</a>
        和其他协议，或者为了保护您、本网站、我们的客户或其他人的生命、财产或其他实质性合法利益，我们将会提供账户或其他个人信息。这包括为防止欺诈问题和减少信用风险而与其他公司和组织交换信息。
      </li>
    </ul>
    <p>
      除以上规定之外，当有关您的信息有可能披露给第三方时，您将会得到通知，并且您将有机会选择不与第三方共享此信息。
    </p>
    <h3>个人信息跨境提供</h3>
    <p>
      为提供跨境电子商务交易、设备或系统的技术支持和维护、保障信息安全以及进行运营管理等，我们可能将我们收集的部分个人信息提供至中国境外的亚马逊关联公司，或允许中国境外的亚马逊关联公司访问存储在中国境内的个人信息。我们将遵守适用法律的规定，通过合同约定、内部政策和标准等形式确保您的个人信息在中国境外获得至少与中国境内适用要求同等的保护。
    </p>
    <h3>关于我的信息安全</h3>
    <p>我们的系统设计考虑到了您的安全和隐私。</p>
    <ul>
      <li>我们通过使用加密协议和软件保护您的个人信息在传输过程中的安全。</li>
      <li>
        我们处理信用卡数据时严格执行支付卡行业数据安全规范（PCI DSS）相关要求。
      </li>
      <li>
        我们维护与个人信息的收集、存储和披露相关的物理、电子和程序性的安全保障。我们的安全保障程序意味着，在向您披露个人信息之前，我们有时可能会要求您提供身份证明。
      </li>
      <li>
        我们的设备提供安全功能，防止未经授权的访问和数据丢失。您可以控制这些功能，并根据您的需求进行配置。
      </li>
      <li>
        防止他人未经授权使用您的密码或使用您的计算机或移动设备是非常重要的。因此，您应确保在与他人共用一台计算机或移动设备时，使用完毕后即时退出登录。
      </li>
    </ul>
    <h3>关于广告</h3>
    <ul>
      <li>
        第三方广告商和其他网站的链接：亚马逊服务可能有第三方广告和对其它网站或应用程序的链接。第三方广告合作伙伴可能会在您与他们的内容、广告和服务交互时收集有关您的信息。欲了解更多关于亚马逊第三方广告，包括基于兴趣的广告，请阅读我们的
        <a data-path="protocol" data-title="ADVERTISEMENT"> 基于兴趣的广告 </a>政策。 若要调整广告偏好，请转到<a data-path="adPreference">广告偏好设置</a>页面。
      </li>
      <li>
        使用第三方广告服务：我们为广告公司提供信息，使他们能够为您提供更有用、更相关的亚马逊广告，并衡量其效果。当我们这样做时，我们从不共享您的姓名或其他直接识别您的信息。相反，我们使用广告标识符，
        如Cookie设备识别码或应用不可逆加密技术于其他信息（如电子邮件地址）而产生的代码。例如，如果您已经下载了我们的某一个应用程序，我们将共享您的广告标识符和有关该事件的数据，这样您就不会收到再次下载应用程序的广告。一些广告公司也利用这些信息为你提供其他商家的相关广告。您可以通过进入
        <a data-path="adPreference"> 广告偏好设置</a>页面了解更多关于如何选择退出基于兴趣的广告的信息。
      </li>
    </ul>
    <h3>我能获取哪些信息？</h3>
    <p>
      您可以访问您的信息，包括您的姓名、地址、付款方式、个人资料信息、主要会员资格、家庭设置，以及在“您的账户”部分的网站购买历史。
    </p>
    <h3>我有哪些选择？</h3>
    <p>
      如果您对我们如何收集和处理您的个人信息有任何疑问，请联系我们的<a data-path="contactCS">客服</a>。我们的许多亚马逊服务还包括供您选择您的信息如何被使用的设置。
    </p>
    <ul>
      <li>
        如上所述，您可以选择不提供某些信息，但之后您可能无法使用相应的亚马逊服务。
      </li>
      <li>
        您可以从您的账户添加或更新某些信息。当您更新信息时，我们通常会保留一份原有信息的复件存档。
      </li>
      <li>
        如果您不想收到我们的电子邮件，请调整您的电子邮件偏好设置。如果您不想收到我们的应用内通知，请调整您在应用或设备中的通知设置。
      </li>
      <li>
        如果您不想看到基于兴趣的广告，请调整您的<a data-path="adPreference">广告偏好设置</a>。
      </li>
      <li>
        多数浏览器上工具条中的帮助部分会告诉您怎样防止您的浏览器接受新的Cookies,怎样让您的浏览器在您收到一条新Cookie时通知您或者怎样彻底关闭Cookies。
        由于Cookie和其他标识符能让您充分利用本网站最优秀的特色服务，所以我们建议您将其设置为打开状态。例如，如果您关闭或禁止接受我们的Cookies，就不能向您的购物车添加商品，
        进入自行结账程序，或者不能使用您需要登录后才能使用的本网站产品和服务。有关Cookies和其他识别码的更多信息，请参见我们的<a data-path="protocol" data-title="COOKIES_POLICY" >Cookies政策</a>。
      </li>
      <li>
        如果您希望浏览我们的网站而不将浏览历史记录链接到您的账户，您可以退出您的账户并在您的浏览器上屏蔽Cookies来实现。
      </li>
      <li>您可以关闭您的亚马逊账户以撤回您同意我们处理您的个人信息。</li>
      <li>
        您还可以通过更新您在适用的亚马逊网站（例如“内容和设备”）、设备或应用程序上的设置，选择退出某些其他类型的数据处理。大多数非亚马逊设备还为用户提供了更改设备权限的功能（例如禁用/访问位置服务、联系人）。
        对于大多数设备，这些控制位于设备的设置菜单中。如果您对如何在第三方制造的设备上更改设备权限存在疑问，我们建议您联系您的移动服务运营商或设备制造商。
      </li>
      <li>
        另外，在适用法律要求的范围内，如您还有其他访问、删除或更正您的个人信息的请求，请联系<a data-path="contactCS"> 客服</a>。您也可以前往
        <a data-path="https://www.amazon.cn/hz/privacy-central/data-requests/preview.html?nativeTitle=获取我的数据&isHideTopNavBar=0">请求我的数据</a>
        提交获取个人信息请求， 或点击<a data-path="deleteAccount">此处</a>
        注销您的亚马逊账户。 根据您的选择，某些服务可能部分或者全部不可用。
      </li>
    </ul>
    <h3>我们将在多长时间内存储您的个人信息？</h3>
    <p>
      我们存储您的个人信息，以使您能够继续使用亚马逊服务，我们仅在满足本隐私声明中描述的相关目的所必需的时间内存储，我们还可能根据法律的要求，如税务或会计等方面的法律要求进行存储，
      否则我们会向您提前告知。例如，我们保留您的交易历史，以便您可以查看过去的购买记录（如需，可以重复订单）以及您将订单发送到了什么地址。
    </p>
    <h3>是否允许未成年人使用本网站？</h3>
    <p>
      我们不向未成年人销售产品，但我们向成年人销售未成年人用品。如果您不满18岁，只有在父母或监护人参与的情况下您才能使用本网站。
    </p>
    <h3>使用条件、通知和修订</h3>
    <p>
      如果您选择访问本网站，您的访问和有关隐私的争议将受制于本声明和我们的 <a data-path="termStatement" data-title="USE_CONDITION" >使用条件</a>，
      包括对赔偿的限制、争议解决和中华人民共和国法律的适用。如果您有任何对本网站上有关隐私问题，请联系我们并作充分描述，我们将尽力为您解决。
    </p>
    <p>
      我们的业务时常变化，我们的隐私声明也随之变化。您应该经常查看我们的网站以了解最新的变更。除另有声明外，现行的隐私声明适用于我们关于您和您的账户的所有信息。
      我们坚守我们做出的承诺，未经受影响的客户同意的情况下，我们不会对我们的政策和实践作实质性修改以至于降低对个人信息的保护程度。相关惯例和信息请见：
    </p>
    <ul>
      <li>
        <a data-path="termStatement" data-title="USE_CONDITION">使用条件</a>
      </li>
      <li>
        <a data-path="contactCS">帮助中心</a>
      </li>
      <li>
        <a data-path="yoOrderList">最近的购买</a>
      </li>
      <li>
        <a data-path="protocol" data-title="COMMUNITY_GUIDELINES"> 您的公开资料和社区准则 </a>
      </li>
    </ul>
    <h3>如何联系我们</h3>
    <p>
      如果您关于亚马逊如何处理您的个人信息有任何疑问或想联系相关的个人信息处理者，请联系我们的<a data-path="contactCS">客服</a>
      或发送邮件至cnprivacy{'@'}amazon.com。请您对问题提供详细描述，我们将尽力为您解决相关问题。一般情况下，我们将在15个工作日内回复您。
    </p>
    <h3>有关信息采集的其他细节</h3>
    <h3>业务功能</h3>
    <p>
      以下所列各项为亚马逊业务功能相关的个人信息类型。<u>下划线</u>所示为个人敏感信息，供您参考：
    </p>
    <ul>
      <li>
        创建您的亚马逊账户。为了创建账户，我们将要求您提供您的姓名和电话号码，并为账户设定密码。您也可以选择向我们提供您的电子邮件地址。如果您通过登录微信账号的方式创建亚马逊账户，
        微信将向我们提供您的账户昵称和头像。您的亚马逊账户创建完成后，您可以选择在您的账户中补充其他信息，如您地址信息中的姓名、地址和电话号码、您的公开资料中的个人描述和照片。
      </li>
      <li>
        在亚马逊在线商店中浏览或购物当您在我们的在线商店搜索或购买商品或服务时，我们会自动收集某些特定类型的信息。这些信息可能包括用于将您的计算机与互联网连接的互联网协议（IP）地址和设备性能指标，如设备何时使用、
        应用程序使用情况、连接数据以及任何错误或发生故障的事件。我们还将收集关于您的搜索历史、与网站内容的交互信息以及您移入和移出购物车的商品和服务信息。为了提升您的购物体验，您还可以选择编辑心愿单或礼品登记、设定特别事件提醒，或使用警告功能，如可订货产品通知等。
        微信将向我们提供您的账户昵称和头像。您的亚马逊账户创建完成后，您可以选择在您的账户中补充其他信息，如您地址信息中的姓名、地址和电话号码、您的公开资料中的个人描述和照片。
      </li>
      <li>
        使用亚马逊小程序。如果您使用我们的小程序，小程序的渠道提供者可能会向我们提供您的手机号码、收货地址和<u>身份证号码</u>。采集这些信息对于我们完成您在小程序中的购物和交易而言是必要的。
      </li>
      <li>
        订购下单。当您准备购买我们的海外购商品时，我们将要求您提供您的姓名、电话号码、收货地址和身份相关资料，包括您的<u>身份证号码</u>或<u>身份证复印件</u>，以方便我们货物运输、进行清关或遵守包括外汇管制在内的其他现行法规。
        就您的订单而言，我们也可能会从第三方采集信息，例如由我们的承运人提供的最新的送货地址信息，我们将使用这些信息来更新我们的记录，以便于向您交付下一次购买的商品。
      </li>
      <li>
        支付商品、内容和服务费用。您可以选择通过向我们提供支付卡信息，或者通过微信支付、支付宝等第三方支付工具进行支付。如果您选择使用第三方支付工具，我们将向支付服务提供商发送订单的详细信息，
        他们将在您付款后及时通知我们。与您在结账时向我们提供支付信息不同，您可以选择通过在您的账户钱包中添加支付工具，或者设置支付选项，如一键下单设置。
      </li>
      <li>
        与客户支持部门进行沟通：我们将采集您通过电话或电子邮件等方式提交给我们的客户服务人员的任何信息，包括用于联系我们的客户服务团队的电话号码或电子邮件地址。
        为了保护您的隐私和安全，我们的客户服务人员可能会通过问您问题的方式验证您的身份。我们也可能与您就您的订单进行沟通。
      </li>
      <li>
        参加社区活动：亚马逊服务包括采取各种方法，供您就我们提供的服务和通过我们的在线商店购买的商品提交反馈。我们将采集您通过这些论坛提供的任何信息。
      </li>
    </ul>
    <h3>软件开发包（ "SDK" ）</h3>
    <p>
      我们收集的个人信息可能会使用第三方SDK进行处理，以简化客户注册、发送推送通知和进行支付。点击<a data-path="protocol" data-title="SDK">此处</a>查看我们接入的SDK详情。
    </p>
    <h3>您使用亚马逊服务时提供给我们的信息</h3>
    <p>您在以下场景会向我们提供信息：</p>
    <ul>
      <li>在在线商店搜索或购买产品或服务；</li>
      <li>在购物车中添加或删除商品，或通过亚马逊服务下单或使用亚马逊服务；</li>
      <li>在设备上或通过设备上的服务或应用程序下载、查看或使用内容；</li>
      <li>
        在<a data-path="openAccountSecurityPage">我的账户</a>（如果您在与我们一起购物时使用了多个电子邮件地址或手机号码，您可能会有多个账户）或您的公开资料中提供信息；
      </li>
      <li>上传您的 联系方式 ；</li>
      <li>
        在亚马逊设备或服务上配置您的设置，为其提供数据访问权限，或与之交互；
      </li>
      <li>通过亚马逊服务提供您的产品或服务；</li>
      <li>通过电话、电子邮件或其他方式与我们沟通；</li>
      <li>通过相册上传图片或通过麦克风和相机录制视频，以发表客户评论；</li>
      <li>填写问卷、支持票或竞赛报名表；</li>
      <li>使用我们的服务，如海外购App；</li>
      <li>参与讨论板或其他社区特别活动；</li>
      <li>提交和对评论进行评估；</li>
      <li>指定在特殊时间提醒；</li>
      <li>启用产品可用性推送，如订单通知。 以及</li>
      <li>为阅读本地电子书或下载电子书到SD卡而提供读写外置存储器权限。</li>
    </ul>
    <h3>作为这些行为的结果，您可能向我们提供以下信息：</h3>
    <ul>
      <li>识别信息，如您的姓名、地址和电话号码；</li>
      <li><u>支付信息</u>；</li>
      <li><u>您的位置信息</u>；</li>
      <li>地址中列出的姓名、地址和电话号码；</li>
      <li>给我们的评论和电子邮件内容；</li>
      <li>您的公开资料中的自我介绍或照片</li>
      <li>关于身份的信息和文件，包括<u>身份证号码</u>；</li>
      <li>公司和财务信息；以及</li>
      <li>
        设备日志文件和配置，包括Wi-Fi证书，如果您选择自动与您的其他亚马逊设备同步。
      </li>
    </ul>
    <h3>自动获取的信息</h3>
    <p>我们收集并分析的信息的包括：</p>
    <ul>
      <li>用来把您的计算机或移动设备连接到因特网上的IP地址；</li>
      <li>登录信息、电子邮件地址和密码；</li>
      <li>软件安装列表，用于支持自动登录您设备上的亚马逊应用;</li>
      <li>
        设备识别码（包括IMEI, IMSI，安卓ID及设备MAC地址），其收集也可能在应用程序后台运行时发生，用于防止和检测欺诈及滥用以保护我们客户、亚马逊和其他人的安全；
      </li>
      <li><u>设备或计算机的位置</u>；</li>
      <li>
        内容交互信息，如内容下载和包括有关您的互联网服务提供商信息的网络详细信息；
      </li>
      <li>
        设备指标，如设备使用时间、应用程序使用情况、连接数据以及任何错误或事件故障；
      </li>
      <li>
        亚马逊服务指标（例如，技术错误的发生、您与服务功能和内容的交互、您的设置首选项和备份信息、运行应用程序设备的位置）；
      </li>
      <li>版本和时区设置；</li>
      <li>
        购物记录及内容使用历史记录，我们有时将之与来自其他客户的类似信息结合起来创造网站特色例如畅销商品；
      </li>
      <li>
        完整的网站 URL点击情况 ，包括日期和时间； 您查看或搜索的产品和内容；页面响应时间、下载错误、访问特定页面的时长以及页面交互信息 （如滚动、点击和光标停留）；
      </li>
      <li>您用来联系我们客户服务部门的电话号码；</li>
      <li>
        动态传感器信息，包括重力传感器、加速度计等用于屏幕方向自适用转动及提升页面呈现效果；以及
      </li>
      <li>通过自启动获取您的通知设置状态以向您发送通知。</li>
    </ul>
    <p>
      我们还可能在设备、应用程序和我们的网页上使用设备识别码、Cookies和其他技术来收集浏览、使用或其他技术信息。
    </p>
    <h3>从其他来源获得的信息</h3>
    <p>我们从其他来源获得的信息包括：</p>
    <ul>
      <li>
        从我们的承运商或其他第三方得到的更新的 配送和地址信息，这些信息供我们更正我们的记录和易于交付您下一次的订货或者便于与您联系；
      </li>
      <li>
        来自第三方（例如微信）的账户信息，以使得您使用您的微信认证来设置您的账户；
      </li>
      <li>
        账户信息、 购买或退货信息，以及通过我们的合作企业或为我们提供技术、履行、广告或其他服务的商家获得的页面阅览信息；
      </li>
      <li>通过我们的关联企业提供的产品和服务互动的信息；和</li>
      <li>搜索结果和链接，包括付费搜索名单（如赞助链接）。</li>
    </ul>
    <h3>您可以获取的信息</h3>
    <p>您可以通过亚马逊服务获得的信息包括：</p>
    <ul>
      <li>最近订单的状态（包括订阅）；</li>
      <li>您的完整 订单历史记录 ；</li>
      <li>个人身份信息（包括姓名、电子邮件、手机号码、 密码 和 地址簿 ）；</li>
      <li>
        付款设置（包括<u>支付卡信息</u>、促销证书、礼品卡余额以及一键下单设置）；
      </li>
      <li>邮件通知设置（包括产品可用性提醒、交货、特别事件提醒和简讯）；</li>
      <li>作为推荐依据的 您最近查看的推荐和产品 （包括为我推荐和优化商品推荐）；</li>
      <li>购物清单；</li>
      <li>您的内容、设备、服务和相关设置，以及通信和个性化广告偏好；</li>
      <li>您最近查看的内容 ；和</li>
      <li>您的公开资料（包括您的产品评论、照片和个人公开资料）</li>
    </ul>
  `
};
